import {TextBox} from "devextreme-react";
import {useEffect, useState} from "react";
import {useFormContext, useFormState} from "react-hook-form";

interface IProps {
    title?: string;
    fieldName: string;
    showBorder?: boolean;
    width?: number;
    modelField?: string;
    index?: number;
    tableName?: string;
    tableFieldName?: string;
}

export const NFPlainText = ({
                                title,
                                fieldName,
                                showBorder = true,
                                width,
                                modelField,
                                index,
                                tableName,
                                tableFieldName,
                            }: IProps) => {

    // const [textValue, setTextValue] = useState("");
    const {getValues, watch} = useFormContext();

    const watchedFieldName = () => {
        if (tableFieldName && tableName) {
            return  modelField ? `${tableName}[${index}].${modelField}` : `${tableName}[${index}].${tableFieldName}`;
        }
        return modelField ? modelField : fieldName;
    }

    const value = watch(watchedFieldName());
    // if (value) {
    //     setTextValue(value[fieldName]);
    // }
    // console.log("products", getValues("products"));
    // console.log("watchedFieldName", watchedFieldName())
    // console.log("value", value)
    // console.log("fieldName", tableFieldName)
    // console.log("value[fieldName]", value[fieldName])
    // const watchedValue = watch(watchedFieldName());
    // const watchedValue = modelField ? watch(`${tableName}[${index}].${modelField}`) : watch(`${tableName}[${index}].${fieldName}`);
    // const watchedTableValue = watch(`${tableName}[${index}].${tableFieldName}`);

    // console.log(watchedFieldName());
    //
    // useEffect(() => {
    //     if (modelField && watchedValue) {
    //         console.log("field", watchedValue)
    //         console.log("value", getValues(watchedValue));
    //         // setTextValue(watchedValue[fieldName]);
    //     // } else {
    //     //     setTextValue(watchedValue);
    //     }
    // }, [watchedValue]);
    //
    // useEffect(() => {
    //     console.log("watch", watch(watchedFieldName()));
    // }, [getValues(watchedFieldName())]);
    
    // useEffect(() => {
    //     if (tableFieldName && tableName) {
    //         const value = getValues(`${tableName}[${index}].${tableFieldName}`);
    //         setTextValue(value);
    //     }
    // }, [fieldName, tableFieldName, tableName, index]);

    const getTextValue = () => {
        if (modelField && value && tableFieldName) {
            return value[tableFieldName];
        }
        return value;
    }
    
    return (
        <div className={title ? "form-group" : ""}>
            {title && <label className={"form-label-sm"}>{title}</label>}
            <TextBox
                value={getTextValue()}
                readOnly={true}
                width={width || undefined}
                style={{border: showBorder === true ? "block" : "none"}}
            />
        </div>
    );
};
